import React from "react";
import Logo from "../../assets/img/Lavenir.jpg";
import ButtonLink from "../../components/button/button";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WhatsappOutlinedIcon from "@mui/icons-material/WhatsappOutlined";

import "./homepage.scss";
const Homepage = () => {
  return (
    <div className="card">
      <img
        className="img-logo"
        src={Logo}
        alt="Lavenir Studio Logo"
        width={150}
      />
      <h1>Lavenir Studio</h1>
      <p>Build your dream home at affordable prices</p>

      {/* icon */}
      <div className="icon-container">
        <a
          className="icon-button instagram"
          href="https://www.instagram.com/lavenir.studio/"
          target="_blank"
          rel="noreferrer"
        >
          <InstagramIcon className="icon icon-instagram" />
        </a>
        <a
          className="icon-button instagram"
          href="https://wa.me/62818405105"
          target="_blank"
          rel="noreferrer"
        >
          <WhatsappOutlinedIcon className="icon icon-whatsapp" />
        </a>
        <a
          className="icon-button instagram"
          href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info.lavenirstudio@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          <EmailOutlinedIcon className="icon icon-email" />
        </a>
      </div>

      {/* button */}
      <div className="button-container">
        <a
          className="button_link"
          href="https://www.canva.com/design/DAE0sMaG2vo/tbnp3Ae05mUsn6BgrpG4eg/view?utm_content=DAE0sMaG2vo&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
          target="_blank"
          rel="noreferrer"
        >
          <ButtonLink text="Company Profile" />
        </a>
        <a
          className="button_link"
          href="https://wa.me/62818405105"
          target="_blank"
          rel="noreferrer"
        >
          <ButtonLink text="Free Konsultasi" />
        </a>
        <a
          className="button_link"
          href="https://www.linkedin.com/company/lavenir-studio"
          target="_blank"
          rel="noreferrer"
        >
          <ButtonLink text="LinkedIn" />
        </a>
        <a
          className="button_link"
          href="https://www.tokopedia.com/lavenirstudio"
          target="_blank"
          rel="noreferrer"
        >
          <ButtonLink text="Tokopedia" />
        </a>
      </div>
    </div>
  );
};

export default Homepage;
